import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { pageUrls } from 'globalconfig/constants/keys';
import Region from './Region';

const RegionList = ({ data, history, callback, updateRegion, deleteRegion, Styled, isCrudRestricted, neglectAccessLevel }) => {
  const match = useParams();
  const regions = data?.data?.regionsDtos;
  const currentId = match.id;

  useEffect(() => {
    const shouldSelectFirst = regions?.length && (!currentId || currentId === 'default' || !regions.some((r) => String(r.id) === String(currentId)));
    if (shouldSelectFirst) {
      history.replace(pageUrls.departmentsList.replace(':id', regions[0].id));
    }
  }, [regions, currentId, history]);

  return (
    <Styled.RegionListWrapper>
      {data?.data?.regionsDtos?.map((item) => (
        <Region
          region={item}
          fleetManagers={data?.data?.fleetManagers}
          serviceCenters={data?.data?.serviceCenters}
          history={history}
          key={item.id}
          callback={callback}
          updateRegion={updateRegion}
          deleteRegion={deleteRegion}
          isCrudRestricted={isCrudRestricted}
          Styled={Styled}
          neglectAccessLevel={neglectAccessLevel}
        />
      ))}
    </Styled.RegionListWrapper>
  );
};

export default RegionList;

RegionList.propTypes = {
  regions: PropTypes.array,
};
